import AssignmentTurnedInIcon from "@material-ui/icons/AssignmentTurnedIn";
import React from "react";
import CustomButton from "../../common/buttons/CustomButton";
import TranslatedMessage from "../../translations/TranslatedMessage";

type CompleteTaskButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

const CompleteTaskButton = ({ onClick, disabled }: CompleteTaskButtonProps) => (
  <CustomButton
    tooltip={<TranslatedMessage id="cancellationTaskForm.completeTask" />}
    onClick={onClick}
    disabled={disabled}
  >
    <AssignmentTurnedInIcon />
  </CustomButton>
);

export default CompleteTaskButton;
